/**
 * 获取页面的最终链接
 * 如果全局定义了 globalGetGotoLink 函数，则使用该函数处理链接
 * 否则，直接返回原始链接
 * @param {Object} params - 包含链接和其他参数的对象
 * @param {string} params.link - 原始链接
 * @param {...any} [params.otherParams] - 其他可选参数
 * @returns {string} - 处理后的链接
 */
export const getGlobalGetGotoLink = ({ link, ...otherParams }) => {
  // 如果链接不存在，则直接返回
  if (!link) {
    return link;
  }
  // 尝试获取全局的 globalGetGotoLink 函数
  const globalGetGotoLink =
    typeof window.globalGetGotoLink === 'function'
      ? window.globalGetGotoLink
      : null;

  try {
    // 如果 globalGetGotoLink 函数存在，则使用它处理链接
    if (globalGetGotoLink) {
      return globalGetGotoLink({ link, ...otherParams });
      // 否则，警告并返回原始链接
    } else {
      console.warn(
        'globalGetGotoLink function is not defined. Returning link as fallback.'
      );
      return link;
    }
    // 如果在调用 globalGetGotoLink 时发生错误，记录错误并返回原始链接
  } catch (error) {
    console.error('Error calling globalGetGotoLink:', error);
    return link;
  }
};

/**
 * 获取页面的链接参数对象
 * 如果全局定义了 globalGetLinkParams 函数，则使用该函数获取参数对象
 * 否则，返回一个默认参数对象
 * @returns {Object} - 包含链接参数的对象
 */
export const getGlobalGetLinkParams = params => {
  let defaultParams = {};

  // 尝试获取全局的 globalGetLinkParams 函数
  const globalGetLinkParamsFunc =
    typeof window.globalGetLinkParams === 'function'
      ? window.globalGetLinkParams
      : null;

  try {
    // 如果 globalGetLinkParams 函数存在，则使用它获取参数对象
    if (globalGetLinkParamsFunc) {
      return globalGetLinkParamsFunc(params);
    } else {
      console.warn(
        'globalGetLinkParams function is not defined. Returning default params as fallback.'
      );
      return defaultParams;
    }
  } catch (error) {
    console.error('Error calling globalGetLinkParams:', error);
    return defaultParams;
  }
};

/**
 * 获取直跳、切支付方式参数并映射为上报字段
 * 若 window.globalGetPayDirectParams 存在则调用，否则返回空对象
 * @returns {{ storePayDirect?: string, storePayJumpMode?: string }}
 */
export const getGlobalPayDirectParams = () => {
  const defaultParams = {};

  const globalGetPayDirectParamsFunc =
    typeof window.globalGetPayDirectParams === 'function'
      ? window.globalGetPayDirectParams
      : null;

  try {
    if (globalGetPayDirectParamsFunc) {
      const directParams = globalGetPayDirectParamsFunc() || {};
      return {
        storePayDirect: directParams?.pay_direct || '',
        storePayJumpMode: directParams?.pay_jump_mode || '',
      };
    }
    return defaultParams;
  } catch (error) {
    console.error('Error calling globalGetPayDirectParams:', error);
    return defaultParams;
  }
};
